import React from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';

import Avatar from 'components/Avatar';
import { imagePickSize, getLocalDateString } from 'utils/general';

const UserActivity = ({
  user,
  date,
  className,
  message,
}) => {

  const { fullname, profileImage, initials } = user;
  let imagePath = null;
  if (profileImage) {
    const relativePath = profileImage?.resolutions?.square60 ?
      imagePickSize(profileImage, 'square60') :
      imagePickSize(profileImage, 'full');
    imagePath = `//${process.env.REACT_APP_AWS_CLOUDFRONT}/${relativePath}`;
  }

  const formatedDate = date ? dayjs(date).format('MM/DD/YYYY') : '';
  const localDateString = getLocalDateString(formatedDate);

  return (
    <div className={clsx('inline-avatar', 'user-activity', className)}>
      <div className="inline-avatar__image">
        <Avatar
          photo={imagePath}
          text={!imagePath ? initials : null}
          size={30}
          borderSize={1}
        />
      </div>
      <div className="inline-avatar__info">
        <p className="inline-avatar__name">
          {fullname} {message}
        </p>
        <div className="inline-avatar__date">
          {localDateString}
        </div>
      </div>
    </div>
  );
};

UserActivity.propTypes = {
  user: PropTypes.object,
  date: PropTypes.string,
  className: PropTypes.string,
  message: PropTypes.string,
};

UserActivity.defaultProps = {
  user: {},
};

export default UserActivity;
